export default {
    url: '/commanders_levels',
    template: require('./view.html'),
    data: {
        title: 'Commanders Levels',
        priority: 900,
    },
    reloadOnSearch: false,
};
